import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {WeeklySnapshot_Chapter} from '@shared/api/models/query/patient-weekly-snapshot.model';
import {ChapterDetailModalComponent} from '@cdss/pages/patient-overview-v2/detail/weekly/components/chapter-detail-modal.component';
import {FullProgrammeModalComponent} from '@cdss/pages/patient-overview-v2/detail/weekly/components/full-programme-modal.component';

@Component({
    selector: 'cdss-weekly-chapter-list',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './weekly-chapter-list.component.html',
    styleUrl: './weekly-chapter-list.component.scss'
})
export class WeeklyChapterListComponent {

    @Input() chapters: WeeklySnapshot_Chapter[] = [];
    @Input() careProgramId: number | null = null;
    /** Overrides the empty-state wording (used when the whole day/week has no data). */
    @Input() noDataText: string | null = null;

    constructor(private modalService: NgbModal) {}

    trackByChapterCode(_index: number, chapter: WeeklySnapshot_Chapter): string {
        return chapter.code;
    }

    openInfo(chapter: WeeklySnapshot_Chapter): void {
        if (!chapter.id || !this.careProgramId) return;
        const ref = this.modalService.open(ChapterDetailModalComponent, {centered: true});
        ref.componentInstance.userCareProgramId = this.careProgramId;
        ref.componentInstance.moduleId = chapter.id;
    }

    openFullProgramme(): void {
        if (!this.careProgramId) return;
        const ref = this.modalService.open(FullProgrammeModalComponent, {centered: true, size: 'xl'});
        ref.componentInstance.careProgramId = this.careProgramId;
    }
}
